export const siteInfo = {
  name: '17C吃瓜站',
  slogan: '现场视频 · 录屏片段 · 直播回放，一网打尽',
  intro:
    '17C吃瓜站专注整理娱乐热点背后的影像资料，把散落在各平台的现场视频、录屏片段与直播回放按专题归档，让你在三分钟内看完全程高光，不错过任何一个名场面。',
  email: 'editor@17cguasite.example.com',
  sloganLine: '每日更新 · 高清截图画质修复 · 全站免费浏览',
};

export const navLinks = [
  { label: '首页', href: '#home' },
  { label: '内容类型', href: '#highlights' },
  { label: '热门合集', href: '#collections' },
  { label: '主题分类', href: '#categories' },
  { label: '精选盘点', href: '#featured' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

export const statItems = [
  { value: '12,800+', label: '已归档影像片段' },
  { value: '360+', label: '持续更新专题' },
  { value: '98.6%', label: '用户播放完成率' },
  { value: '24h', label: '热点更新响应' },
];

export const marqueeTags = [
  '直播回放',
  '现场视频',
  '录屏片段',
  '画面截图',
  '综艺名场面',
  '红毯直拍',
  '幕后花絮',
  '热点追踪',
  '高清修复',
  '合集整理',
];

export const highlights = [
  {
    id: 'h1',
    icon: 'ri-live-line',
    title: '直播回放整段可用',
    desc: '按时间戳切分直播高光片段，跳过冗长等待，直接定位到事件发生的那一刻，支持多清晰度切换。',
  },
  {
    id: 'h2',
    icon: 'ri-record-circle-line',
    title: '现场录屏一手整理',
    desc: '汇总网友录屏与现场直拍，标注拍摄视角与时间线，方便对照还原事件完整经过。',
  },
  {
    id: 'h3',
    icon: 'ri-image-2-line',
    title: '高清截图逐帧还原',
    desc: '对模糊素材做画质修复与逐帧提取，输出可直接引用的高清画面截图，细节看得清。',
  },
  {
    id: 'h4',
    icon: 'ri-folder-shield-2-line',
    title: '专题归档长期可查',
    desc: '每个热点建立独立专题，按时间顺序持续补充视频与截图资料，过段时间回来也能找到。',
  },
];

export const categories = [
  {
    id: 'variety',
    name: '综艺现场',
    desc: '棚内综艺、真人秀与访谈节目里的高能瞬间',
    icon: 'ri-tv-2-line',
    count: 128,
  },
  {
    id: 'ceremony',
    name: '颁奖红毯',
    desc: '颁奖礼、发布会与红毯直拍的完整影像',
    icon: 'ri-award-line',
    count: 96,
  },
  {
    id: 'live',
    name: '直播名场面',
    desc: '直播间突发状况与值得回味的互动时刻',
    icon: 'ri-broadcast-line',
    count: 154,
  },
  {
    id: 'backstage',
    name: '幕后花絮',
    desc: '台前之外的排练、探班与采访片段',
    icon: 'ri-film-line',
    count: 87,
  },
  {
    id: 'trending',
    name: '热点追踪',
    desc: '跟随话题热度梳理事件的来龙去脉',
    icon: 'ri-fire-line',
    count: 112,
  },
  {
    id: 'screenshot',
    name: '高清截图',
    desc: '逐帧修复的画面截图与表情包素材',
    icon: 'ri-gallery-line',
    count: 203,
  },
];

export const collections = [
  {
    id: 'c1',
    title: '音乐节舞台全记录：从彩排到返场加时',
    categoryId: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Live%20music%20festival%20stage%20with%20dramatic%20purple%20stage%20lights%20and%20crowd%20silhouettes%2C%20energetic%20atmosphere%2C%20wide%20shot%2C%20cinematic%20photography&width=800&height=500&seq=gs-coll-01&orientation=landscape',
    duration: '18:42',
    views: '24.6万',
    date: '2026-09-08',
    tags: ['舞台直拍', '返场', '完整版'],
    summary: '收录主舞台彩排走位、正式演出与返场加时的三段完整录屏，附带机位切换视角。',
  },
  {
    id: 'c2',
    title: '年度盛典红毯直拍合集：一小时看懂造型亮点',
    categoryId: 'ceremony',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20awards%20night%20entrance%20with%20spotlights%20and%20velvet%20ropes%2C%20warm%20golden%20lighting%2C%20glamorous%20wide%20shot&width=800&height=500&seq=gs-coll-02&orientation=landscape',
    duration: '62:10',
    views: '31.2万',
    date: '2026-09-05',
    tags: ['红毯', '造型', '慢镜回放'],
    summary: '按出场顺序整理的红毯直拍，每个造型都配了慢镜回放与现场收音，方便逐位回看。',
  },
  {
    id: 'c3',
    title: '直播间突发连线中断，主播十分钟救场实录',
    categoryId: 'live',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20with%20ring%20light%20and%20microphones%2C%20cozy%20warm%20ambient%20lighting%2C%20nobody%20in%20frame%2C%20interior%20photography&width=800&height=500&seq=gs-coll-03&orientation=landscape',
    duration: '11:05',
    views: '19.8万',
    date: '2026-09-03',
    tags: ['救场', '名场面', '收音完整'],
    summary: '连线意外中断的完整时间线录屏，包含主播临场应对与弹幕同屏画面。',
  },
  {
    id: 'c4',
    title: '剧组开机首日探班：幕后花絮与主创采访',
    categoryId: 'backstage',
    cover:
      'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20camera%20rig%20and%20softboxes%2C%20warm%20afternoon%20light%2C%20documentary%20style%20wide%20photograph&width=800&height=500&seq=gs-coll-04&orientation=landscape',
    duration: '09:36',
    views: '12.3万',
    date: '2026-08-30',
    tags: ['探班', '采访', '竖屏版'],
    summary: '开机首日现场花絮，附主创群访录音整理与两段横竖屏对照组画面。',
  },
  {
    id: 'c5',
    title: '综艺名场面复盘：三分钟看完本期所有高能点',
    categoryId: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Colorful%20tv%20variety%20show%20studio%20with%20round%20stage%20and%20neon%20accent%20lighting%2C%20empty%20audience%20seats%2C%20wide%20interior%20shot&width=800&height=500&seq=gs-coll-05&orientation=landscape',
    duration: '03:18',
    views: '27.9万',
    date: '2026-08-27',
    tags: ['名场面', '剪辑版', '高能'],
    summary: '把本期节目里所有出圈片段剪成一支短片，按笑点密度排序，下饭首选。',
  },
  {
    id: 'c6',
    title: '热点话题时间线梳理：从发酵到回应',
    categoryId: 'trending',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20timeline%20concept%20with%20glowing%20nodes%20and%20connecting%20lines%20over%20dark%20teal%20background%2C%20data%20visualization%20aesthetic&width=800&height=500&seq=gs-coll-06&orientation=landscape',
    duration: '07:52',
    views: '22.1万',
    date: '2026-08-24',
    tags: ['时间线', '梳理', '多方视角'],
    summary: '用一条时间线串起事件从话题发酵到各方回应的全过程，关键节点都有对应影像。',
  },
  {
    id: 'c7',
    title: '颁奖礼后台采访间全记录（含未播片段）',
    categoryId: 'ceremony',
    cover:
      'https://readdy.ai/api/search-image?query=Backstage%20press%20interview%20room%20with%20microphone%20stand%20and%20backdrop%20boards%2C%20soft%20warm%20lights%2C%20empty%20chairs%20wide%20shot&width=800&height=500&seq=gs-coll-07&orientation=landscape',
    duration: '34:07',
    views: '15.4万',
    date: '2026-08-21',
    tags: ['后台', '采访', '未播'],
    summary: '媒体采访间的完整机位素材，包含正片未采用的问答与后台走廊花絮。',
  },
  {
    id: 'c8',
    title: '直播连麦名场面：一句话让全场沉默',
    categoryId: 'live',
    cover:
      'https://readdy.ai/api/search-image?query=Minimal%20broadcast%20desk%20setup%20with%20headphones%20and%20mixing%20console%2C%20warm%20amber%20rim%20light%2C%20moody%20interior%20photography&width=800&height=500&seq=gs-coll-08&orientation=landscape',
    duration: '05:44',
    views: '33.7万',
    date: '2026-08-18',
    tags: ['连麦', '名场面', '弹幕同屏'],
    summary: '连麦对话的完整录屏，保留原始弹幕滚动，还原当下最真实的反应。',
  },
  {
    id: 'c9',
    title: '高清热修复：模糊现场素材逐帧还原对比',
    categoryId: 'screenshot',
    cover:
      'https://readdy.ai/api/search-image?query=Photo%20editing%20workspace%20with%20color%20grading%20monitor%20and%20before%20after%20frames%2C%20clean%20modern%20desk%2C%20soft%20natural%20light&width=800&height=500&seq=gs-coll-09&orientation=landscape',
    duration: '06:29',
    views: '9.8万',
    date: '2026-08-15',
    tags: ['画质修复', '对比', '截图'],
    summary: '展示同一段现场素材修复前后的画质差异，并整理出可直接取用的高清截图包。',
  },
  {
    id: 'c10',
    title: '赛季总决赛场外应援实况：人潮与灯牌全景',
    categoryId: 'trending',
    cover:
      'https://readdy.ai/api/search-image?query=Night%20stadium%20exterior%20with%20thousands%20of%20light%20sticks%20and%20cheering%20crowd%2C%20warm%20orange%20glow%2C%20wide%20aerial%20view&width=800&height=500&seq=gs-coll-10&orientation=landscape',
    duration: '14:23',
    views: '18.2万',
    date: '2026-08-11',
    tags: ['应援', '全景', '场外'],
    summary: '场外应援实况多机位合集，从人潮全景到灯牌特写，感受现场氛围的完整记录。',
  },
  {
    id: 'c11',
    title: '综艺游戏环节翻车合集：笑点密度拉满',
    categoryId: 'variety',
    cover:
      'https://readdy.ai/api/search-image?query=Game%20show%20set%20with%20colorful%20props%20and%20buzzer%20podiums%2C%20playful%20bright%20studio%20lighting%2C%20wide%20shot&width=800&height=500&seq=gs-coll-11&orientation=landscape',
    duration: '08:57',
    views: '26.5万',
    date: '2026-08-08',
    tags: ['合集', '笑点', '幕后反应'],
    summary: '把各期节目里的翻车瞬间串成合辑，配上现场反应镜头一起看更上头。',
  },
  {
    id: 'c12',
    title: '高清表情包素材包：本期出圈截图整理',
    categoryId: 'screenshot',
    cover:
      'https://readdy.ai/api/search-image?query=Grid%20of%20colorful%20square%20sticker%20frames%20on%20soft%20cream%20background%2C%20flat%20lay%20design%20composition%2C%20clean%20minimal&width=800&height=500&seq=gs-coll-12&orientation=landscape',
    duration: '00:00',
    views: '11.6万',
    date: '2026-08-04',
    tags: ['表情包', '截图包', '可直接用'],
    summary: '整理本期最出圈的十几帧画面，裁切成统一尺寸，下载后可直接拿去使用。',
  },
];

export const featured = {
  title: '本周精选｜音乐节现场全记录专题',
  subtitle: '一个专题，看完整场',
  cover:
    'https://readdy.ai/api/search-image?query=Wide%20concert%20stage%20view%20from%20side%20wings%20with%20warm%20amber%20and%20green%20stage%20lights%2C%20bokeh%20crowd%2C%20cinematic%20atmosphere&width=1200&height=800&seq=gs-featured-01&orientation=landscape',
  paragraphs: [
    '本周我们把音乐节从彩排到谢幕的影像资料做了一次系统归档。与常见的零散片段不同，这个专题按“彩排走位—正式演出—返场加时”三段时间线排列，每一段都标注了拍摄机位与录制时间，方便你对照现场流程完整回看。',
    '除了主舞台画面，专题还收录了侧翼机位、观众席视角与后台通道的素材。同一个瞬间从不同角度切进去看，往往能发现正片镜头里被带过的细节，这也是我们坚持多机位归档的原因。',
    '所有视频均提供高清截图导出，关键帧做过画质修复处理。如果你只想快速了解亮点，专题顶部也准备了精剪短片；想深入研究，则可以按时间线逐段播放。',
  ],
  stats: [
    { value: '3 段', label: '时间段归档' },
    { value: '7 个', label: '拍摄机位视角' },
    { value: '86 张', label: '高清截图导出' },
  ],
  points: [
    '按时间线排列，还原完整现场流程',
    '多机位对照，细节不遗漏',
    '关键帧画质修复，可直接引用',
    '专题每周更新，长期可回查',
  ],
};

export const faqs = [
  {
    q: '17C吃瓜站的影像资料主要来自哪里？',
    a: '内容以公开渠道流传的现场视频、活动录屏与直播回放为主，由编辑团队做二次整理与归档。我们只做分类、时间线标注与画质处理，不生产也不改写原始画面。',
  },
  {
    q: '合集里的视频可以下载吗？',
    a: '站内提供高清画面截图的下载，视频本身以在线观看为主。每个合集的详情弹窗里都会标注素材类型、时长与推荐观看顺序，方便你先判断是否值得展开看整段。',
  },
  {
    q: '为什么同一个事件会有好几个不同角度的片段？',
    a: '因为我们坚持多机位、多视角归档。导播镜头会带过很多细节，观众席或后台视角常常能补充到关键信息。把不同视角放在一起对照，事件经过会更清楚。',
  },
  {
    q: '更新频率是怎样的？有热点会及时收录吗？',
    a: '专区保持每日更新，遇到关注度较高的话题，编辑会在事发后尽快建立专题并持续补充素材。你可以关注首页的“最新更新”排序，优先看到刚入库的片段。',
  },
  {
    q: '想投稿自己录到的现场片段，该怎么操作？',
    a: '在页面底部的联系表单里选择“素材投稿”，填写素材类型、大致时间与来源说明即可。若画面清晰、时间线完整，我们会联系你补充细节并加入对应专题。',
  },
  {
    q: '站内内容会不会涉及隐私或未授权素材？',
    a: '不会。我们只整理公开发布、已进入公共讨论范围的内容，并会在收到权利人合理异议时第一时间下架相关片段。若你发现有问题内容，可通过联系表单反馈。',
  },
];

export const testimonials = [
  {
    name: '阿舟',
    role: '追热点爱好者',
    text: '以前找名场面得翻好几个平台，现在直接按专题看，时间线标得清清楚楚，省了我大把时间。',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20person%20portrait%20with%20warm%20neutral%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20headshot&width=200&height=200&seq=gs-user-01&orientation=squarish',
  },
  {
    name: '小雨点',
    role: '内容创作者',
    text: '截图包的画质修复做得很到位，做二创时直接拿来用，不用再一帧帧去抠模糊画面了。',
    avatar: 'https://readdy.ai/api/search-image?query=Cheerful%20young%20woman%20portrait%20with%20soft%20cream%20background%2C%20warm%20studio%20lighting%2C%20clean%20editorial%20headshot&width=200&height=200&seq=gs-user-02&orientation=squarish',
  },
  {
    name: '老陈',
    role: '综艺剪辑爱好者',
    text: '最满意的是多机位对照，同一段素材好几个角度都有，剪片子的时候素材库终于够用了。',
    avatar: 'https://readdy.ai/api/search-image?query=Calm%20middle%20aged%20man%20portrait%20with%20warm%20beige%20background%2C%20soft%20light%2C%20clean%20editorial%20headshot&width=200&height=200&seq=gs-user-03&orientation=squarish',
  },
];

export const aboutContent = {
  positioning: '不是资讯媒体，而是一间把娱乐影像资料整理清楚的“档案室”。',
  story:
    '17C吃瓜站始于一群爱看名场面的人。我们厌倦了在碎片化平台之间反复跳转，也受够了模糊到看不清表情的转存画质，于是决定自己动手，把大家关心的现场影像系统整理起来。',
  principles: [
    { title: '只做整理，不造内容', desc: '我们标注来源、时间与视角，尽量还原原始画面，不对事件本身做主观定性。' },
    { title: '清晰优先', desc: '优先归档画质可用、时间线完整的素材，模糊转存会做修复处理后再上线。' },
    { title: '长期可查', desc: '专题一旦建立就会持续维护，热点过去之后，资料依然找得到、看得懂。' },
    { title: '尊重权利', desc: '收到合理异议会第一时间处理，不整理涉及隐私的非公开素材。' },
  ],
};